module.exports = __webpack_public_path__ + "img/eraser-duotone.ddbd2260.svg";